/**
 * Extract the H1 title from markdown content.
 * Falls back to the provided fallback string if no H1 is found.
 */
export function extractGuideTitle(contentMd: string, fallback: string): string {
  const titleLine = contentMd.split('\n').find(l => l.startsWith('# '))
  return titleLine ? `${titleLine.replace(/^#\s+/, '')} | TabeTabi` : fallback
}
